import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, unref as _unref, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "footer__sub" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    onclick: "UC_UI.showSecondLayer();"
  }, "Einwilligungsmanagement")
], -1)

import MenuInterface from '@/interfaces/MenuInterface';
import AppDate from '../../classes/AppDate';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppFooterSub',
  props: {
    items: {}
  },
  setup(__props: any) {



const currentYear = new AppDate().format('Y');

const openUC = (): void => {
  if (window.UC_UI) {
    window.UC_UI.showSecondLayer();
  }
};

return (_ctx: any,_cache: any) => {
  const _component_IoRouterLink = _resolveComponent("IoRouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("nav", null, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (menuItem) => {
              return (_openBlock(), _createElementBlock("li", {
                key: `mifs-${menuItem.id}`
              }, [
                (menuItem.url === '#cookie-einstellungen')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      innerHTML: menuItem.title,
                      onClick: openUC
                    }, null, 8, _hoisted_3))
                  : (_openBlock(), _createBlock(_component_IoRouterLink, {
                      key: 1,
                      "link-url": menuItem.url,
                      "link-target": menuItem.target,
                      "link-title": menuItem.titleAttr,
                      id: `iomi-${ menuItem.id }`,
                      active: menuItem.active
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          innerHTML: menuItem.title
                        }, null, 8, _hoisted_4)
                      ]),
                      _: 2
                    }, 1032, ["link-url", "link-target", "link-title", "id", "active"]))
              ]))
            }), 128)),
            _hoisted_5
          ])
        ])
      ]),
      _createElementVNode("div", null, " © " + _toDisplayString(_unref(currentYear)) + " Stadtwerke Ahrensburg GmbH ", 1)
    ])
  ]))
}
}

})